<template>
  <v-expansion-panels v-model="spanPanels" multiple color="#fff">
    <v-expansion-panel>
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!spanPanels.includes(0)" icon="fa-solid fa-plus" />
        <v-icon v-if="spanPanels.includes(0)" icon="fa-solid fa-minus" />
        <v-row>
          <v-col class="align-left pl-4" cols="4"
            ><h3>Structure Unit ID: {{ span?.strUnitLabel }}</h3></v-col
          >
          <v-col class="align-center" cols="4"
            ><h3>
              Span Type:&nbsp;{{
                span?.legacyStructureType
                  ? configStore.getReferenceValue(REFERENCE_TABLE.STRUCTURE_UNIT_TYPE, span?.legacyStructureType)
                  : ``
              }}
            </h3></v-col
          >
          <v-col class="align-right pr-4" cols="4"
            ><h3>Unit Key: {{ span?.strUnitKey }}</h3></v-col
          >
        </v-row>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-expansion-panels v-model="spanSubPanels" multiple color="#fff">
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!spanSubPanels.includes(0)" icon="fa-solid fa-plus" />
              <v-icon v-if="spanSubPanels.includes(0)" icon="fa-solid fa-minus" />
              <h3>Span {{ span?.strUnitLabel }} Details</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row class="pl-6">
                <v-col cols="12" lg="6" xl="6" class="pl-0 pb-0 pt-0">
                  <LabelText
                    :id="`${id}_unit_key`"
                    label="SU.01 Unit Key"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :model-value="span?.strUnitKey"
                  /> </v-col
                ><v-col cols="12" lg="6" xl="6" class="pb-0 pt-0">
                  <LabelText
                    :id="`${id}_unit_id`"
                    label="SU.02 Unit ID"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :model-value="span?.strUnitLabel"
                  /> </v-col
              ></v-row>
              <v-row
                ><v-col class="pl-6 pt-0">
                  <LabelText
                    labelXl="12"
                    labelLg="12"
                    labelMd="12"
                    labelSm="12"
                    textXl="12"
                    textLg="12"
                    textMd="12"
                    textSm="12"
                    type="textarea"
                    label="SU.03 Structure Unit Description"
                    :id="`${id}_structure_unit_description`"
                    :counter="255"
                    :maxlength="255"
                    :model-value="span?.strUnitDescription"
                  /> </v-col
              ></v-row>
              <v-row class="pl-6">
                <v-col cols="12" lg="6" xl="6" class="pl-0 pb-0 pt-0">
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_legacy_structure_type`"
                    label="SU.04 Legacy Structure Type"
                    :refTable="REFERENCE_TABLE.STRUCTURE_TYPE"
                    :model-value="span?.legacyStructureType"
                  />
                  <LabelText
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :id="`${id}_config_designation`"
                    label="B.SP.01 Span Config. Designation"
                    :model-value="span?.spanConfigDesignation"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_deck_interaction`"
                    label="B.SP.08 Deck Interaction"
                    :refTable="REFERENCE_TABLE.DECK_INTERACTION"
                    :model-value="span?.deckInteraction"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_deck_material_type`"
                    label="B.SP.09 Deck Material and Type"
                    :refTable="REFERENCE_TABLE.DECK_MATERIAL_TYPE"
                    :model-value="span?.deckMaterialAndType"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_wearing_surface`"
                    label="B.SP.10 Wearing Surface"
                    :refTable="REFERENCE_TABLE.WEARING_SURFACE"
                    :model-value="span?.wearingSurface"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_deck_prot_system`"
                    label="B.SP.11 Deck Prot. System"
                    :refTable="REFERENCE_TABLE.DECK_PROTECTIVE_SYSTEM"
                    :model-value="span?.deckProtectSystem"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_deck_reinforcing_prot_sys`"
                    label="B.SP.12 Deck Reinforcing Prot. Sys."
                    :refTable="REFERENCE_TABLE.DECK_REINFORCING_PROTECTIVE_SYSTEM"
                    :model-value="span?.deckReinforceProtectSystem"
                  />
                  <LabelSelect
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    selectXl="6"
                    selectLg="6"
                    selectMd="6"
                    selectSm="6"
                    :id="`${id}_deck_stay_forms`"
                    label="B.SP.13 Deck Stay-in-Place Forms"
                    :refTable="REFERENCE_TABLE.DECK_STAY_IN_PLACE_FORMS"
                    :model-value="span?.deckStayInPlaceForms"
                  />
                </v-col>
                <v-col cols="12" lg="6" xl="6" class="pb-0 pt-0">
                  <LabelText
                    :id="`${id}_min_span_out_to_out_width`"
                    label="SP.23 Minimum Span Out-to-Out Width"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :decimalPlaces="1"
                    maxlength="4"
                    :isEditable="isEditable"
                    :roundingFactor="ROUNDING_FACTOR.TENTH"
                    v-model="minSpanOut2OutWidth"
                  />
                  <LabelText
                    :id="`${id}_span_length`"
                    label="SP.21 Span Length"
                    labelXl="6"
                    labelLg="6"
                    labelMd="6"
                    labelSm="6"
                    textXl="6"
                    textLg="6"
                    textMd="6"
                    textSm="6"
                    :counter="null"
                    type="number"
                    appendWith=" ft"
                    :model-value="span?.spanLength"
                    :decimalPlaces="2"
                    :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!spanSubPanels.includes(1)" icon="fa-solid fa-plus" />
              <v-icon v-if="spanSubPanels.includes(1)" icon="fa-solid fa-minus" />
              <h3>Span {{ span?.strUnitLabel }} Inspection Notes</h3>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.DECK"
                label="Deck Top and Wearing Surface"
                id="field_Deck_Top_And_Wearing_Surface"
                :inspectionCommentType="INSPECTION_COMMENTS.DECK_TOP_WEARING_SURFACE"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span?.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.DECK"
                label="Deck Underside"
                id="field_Deck_Underside"
                :inspectionCommentType="INSPECTION_COMMENTS.DECK_UNDERSIDE"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span?.structureUnitId"
              />
              <StructureUnitCommentTypeTextField
                :pageValue="INSPECTION_PAGES.DECK"
                label="Deck Drainage"
                id="field_Deck_Drainage"
                :inspectionCommentType="INSPECTION_COMMENTS.DECK_DRAINAGE"
                :readOnly="!isEditable"
                :counter="commentsMaxLength"
                :maxlength="commentsMaxLength"
                :structureUnitId="span?.structureUnitId"
              />
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { computed, ref, watch } from "vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import LabelText from "@/components/common/LabelText.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import LabelSelect from "@/components/common/LabelSelect.vue";

export default {
  name: "DeckSpanBySpan",
  props: {
    id: { default: null },
    span: { default: null },
    isEditable: { default: false },
    isExpanded: { default: true },
    structureHeader: { default: null },
  },
  emits: ["updateMinSpanOut2OutWidth"],
  setup(props, ctx) {
    //Common Code
    const configStore = useConfigStore();
    const spanPanels = ref([0]);

    const minSpanOut2OutWidth = computed({
      get() {
        return props.span?.minSpanOut2OutWidth;
      },
      set(value) {
        ctx.emit("updateMinSpanOut2OutWidth", value);
      },
    });

    const spanSubPanels = ref([0, 1]);

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    watch(
      () => [props.isExpanded],
      () => {
        if (props.isExpanded) {
          spanPanels.value = [0];
        } else {
          spanPanels.value = [];
        }
      },
      { deep: true },
    );

    return {
      configStore,
      minSpanOut2OutWidth,
      REFERENCE_TABLE,
      ROUNDING_FACTOR,
      INSPECTION_PAGES,
      spanSubPanels,
      spanPanels,
      commentsMaxLength,
      INSPECTION_COMMENTS,
    };
  },
  components: {
    LabelSelect,
    LabelText,
    StructureUnitCommentTypeTextField,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
</style>
